export var CONSTANCES = {
    clubColumnId: '062846f9-13ac-4c6e-b7a6-ec23a29d239f',
    userDisplayNameColumnId: '0a573c78-2172-449e-af6b-624787c74227',
    sportClubDisplayNameColumnId: '062846f9-13ac-4c6e-b7a6-ec23a29d239f',
    teamDisplayNameColumnId: 'd931b295-0de9-4745-b836-5a615f8e548e',
    distanceColumnId: '6f4f7486-ebd1-47c7-916b-17b15b33760a',
    averageKmPerUserColumnId: 'ceabf430-533a-45d9-99b7-88edffaaef10',
    activenessColumnId: '44fab3fd-0a91-48e5-996b-5c4ab97be6e5'
};
